module.exports = __webpack_public_path__ + "fonts/fa-regular-400.e931bc0.woff2";